var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.208 2.40257L11.4819 11.4821L6.81256 9.118C6.45387 8.93695 6.05482 8.85064 5.65335 8.86735C5.25188 8.88406 4.86134 9.00317 4.51892 9.21342C4.1765 9.42367 3.89355 9.718 3.69699 10.0685C3.50044 10.4189 3.39682 10.8138 3.39598 11.2156C3.39691 11.5987 3.49124 11.9757 3.67079 12.314C3.85035 12.6524 4.10972 12.9418 4.4264 13.1573L8.61141 16.0189L3.39598 24.2888L0 29.6588H8.25812L14.3832 19.9625L27.3239 28.8035C28.1407 29.361 29.1067 29.6591 30.0957 29.6588C30.8805 29.6584 31.6531 29.4647 32.3452 29.0949C33.0374 28.7251 33.6278 28.1905 34.0643 27.5384C34.5009 26.8862 34.77 26.1365 34.8481 25.3557C34.9261 24.5748 34.8106 23.7867 34.5118 23.0611L26.3288 3.18865C24.7375 -0.676919 19.4426 -1.13469 17.208 2.40257ZM17.7321 14.6573L21.2238 9.12683L25.0245 18.3594L17.7321 14.6573Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/m-logo.9d4df3d4b29488778ce13d0d473ffeb3.svg";
export { ForwardRef as ReactComponent };